// extracted by mini-css-extract-plugin
export default {"hidescrollbar":"SuperAdminDashboardCompanyList_hidescrollbar__yQd3p","input":"SuperAdminDashboardCompanyList_input__HqIDJ"};